import { PersonTypes } from '@frontend/api-person';
import { ExtendedAppointment } from '@frontend/schedule-helpers';
import { customContextFactory } from '../../../hooks/custom-context-factory';
import { ScheduleEventAppointmentInfo } from '../../schedule-calendar-components/helpers';

export type ApptPanelContextType = {
  locationId: string;
  selectedAppointment?: ExtendedAppointment;
  apptDetails?: ScheduleEventAppointmentInfo;
  isV3Enabled: boolean;
  isIntegratedOffice: boolean;
  shouldShowOperatory: boolean;
  personInfo?: PersonTypes.Person;
  isLoadingPersonInfo: boolean;
};

export const [ApptPanelContextProvider, useApptPanelContext] = customContextFactory<ApptPanelContextType>();
